import { FinanceEntryType } from "../typeDefs";

export const GST_REGISTRATION_DATE = new Date("2024-05-02T00:00:00").getTime();
export const GST_REGISTRATION_LABEL = "02/05/2024";

export const isInGstRegisteredPeriod = (date: number) => date >= GST_REGISTRATION_DATE;

export const requiresGstDetails = (entry: FinanceEntryType) =>
  isInGstRegisteredPeriod(entry.date) &&
  ["Revenue", "Expenses", "Assets"].includes(entry.category);
